<template>
  <RevTag
    class="rounded-sm bg-static-success-mid"
    :label="i18n(translations.tagContent, { differencePercentage })"
    size="small"
    variant="secondary"
  />
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'

import translations from './HistoricalPriceDifferencePercentage.translations'

const i18n = useI18n()

defineProps<{
  differencePercentage: number
}>()
</script>
